<mat-form-field appearance="fill" class="w-full ">
    <mat-label>{{label}}</mat-label>
    <input matInput [formControl]="phoneNumberControl" placeholder="{{placeholder}}" class="focus:ring-0">
    @if (phoneNumberControl.hasError('required') && phoneNumberControl.touched) {
    <mat-error>{{label}} {{"PARKIFLY.ERROR.IS_REQUIRED" | transloco}}</mat-error>
    }
</mat-form-field>